<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <HeaderComponent></HeaderComponent>
    <router-view />
    <FooterComponent></FooterComponent>
  </div>
</template>
<script>
import FooterComponent from './components/Footer.vue'
import HeaderComponent from './components/Header.vue'
export default {
  components: {
    FooterComponent,
    HeaderComponent
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  font-family: 'PingFang-SC'!important;
}
*::before{
  margin: 0;
  padding: 0;
}
#app {
  overflow: hidden;
}

/* 隐藏垂直滚动条 */
body::-webkit-scrollbar {
  width: 0;
  height: 0;
}

body{
  scrollbar-width: 0;
}

body{
  -ms-overflow-style: none;
}

</style>
